import somnus from '../assets/images/papers/somnus.png'
import somnusFile from '../assets/files/papers/somnus.pdf'

import comantics from '../assets/images/papers/comantics.png'
import comanticsFile from '../assets/files/papers/comantics.pdf'

import nebula from '../assets/images/papers/nebula.png'
import nebulaFile from '../assets/files/papers/nebula.pdf'

import color from '../assets/images/papers/color.png'
import colorFile from '../assets/files/papers/color.pdf'

import layout from '../assets/images/papers/layout.png'
import layoutFile from '../assets/files/papers/layout.pdf'

import shuttlespace from '../assets/images/papers/shuttlespace.png'
import shuttlespaceFile from '../assets/files/papers/shuttlespace.pdf'

import narvis from '../assets/images/papers/narvis.png'
import narvisFile from '../assets/files/papers/narvis.pdf'

import tcal from '../assets/images/papers/tcal.png'
import tcalFile from '../assets/files/papers/tcal.pdf'

import treeevo from '../assets/images/papers/treeevo.png'
import treeevoFile from '../assets/files/papers/treeevo.pdf'

import iforum from '../assets/images/papers/iforum.jpg'
import iforumFile from '../assets/files/papers/iforum.pdf'


var pub = [
  {
    authors:
      'Kai Xiong, Zhongsu Luo, Siwei Fu*, Yongheng Wang*, Mingliang Xu, Yingcai Wu',
    year: 2022,
    title: 'Revealing the Semantics of Data Wrangling Scripts With COMANTICS',
    venueLong: 'IEEE Transactions on Visualization & Computer Graphics',
    venue: 'TVCG',
    url: 'https://ieeexplore.ieee.org/document/9904459',
    teaser: comantics,
    pdf: comanticsFile,
    video: 'https://youtu.be/acVSqJQ3jnQ',
  },
  {
    authors:
      'Kai Xiong, Siwei Fu*, Guoming Ding, Zhongsu Luo, Rong Yu, Wei Chen, Hujun Bao, Yingcai Wu*',
    year: 2022,
    title: 'Visualizing the Scripts of Data Wrangling with SOMNUS',
    venueLong: 'IEEE Transactions on Visualization & Computer Graphics',
    venue: 'TVCG',
    url: 'https://www.computer.org/csdl/journal/tg/5555/01/09693232/1As79CUmeZO',
    teaser: somnus,
    pdf: somnusFile,
    video: 'https://github.com/xkKevin/Somnus',
  },
  {
    authors:
      'Ran Chen, Xinhuan Shu, Jiahui Chen, Di Weng, Junxiu Tang, Siwei Fu*, Yingcai Wu*',
    year: 2022,
    title: 'Nebula: A Coordinating Grammar of Graphics',
    venueLong: 'IEEE Transactions on Visualization & Computer Graphics',
    venue: 'TVCG',
    url: 'https://www.computer.org/csdl/journal/tg/5555/01/09417674/1taANyFFcmQ',
    teaser: nebula,
    pdf: nebulaFile,
    video: 'https://youtu.be/oMgO0BVX8rY',
  },
  {
    authors:
      'Linping Yuan, Wei Zeng, Siwei Fu, Zhiliang Zeng, Haotian Li, Chi-Wing Fu, Huamin Qu',
    year: 2022,
    title: 'Deep Colormap Extraction from Visualizations',
    venueLong: 'IEEE Transactions on Visualization & Computer Graphics',
    venue: 'TVCG',
    url: 'https://ieeexplore.ieee.org/document/9395231',
    teaser: color,
    pdf: colorFile,
    video: 'https://github.com/yuanlinping/deep_colormap_extraction',
  },
  {
    authors:
      'Jiacheng Pan, Wei Chen, Xiaodong Zhao, Shuyue Zhou, Wei Zeng, Minfeng Zhu, Jian Chen, Siwei Fu, Yingcai Wu',
    year: 2021,
    title: 'Exemplar-based layout fine-tuning for node-link diagrams',
    venueLong: "IEEE Transactions on Visualization & Computer Graphics (Proceedings of VIS'20)",
    venue: 'TVCG',
    url: '#',
    teaser: layout,
    pdf: layoutFile,
    video: 'https://www.youtube.com/watch?v=qpsBOtN2kcQ&ab_channel=IEEEVisConference2020',
  },
  {
    authors:
      'Shuainan Ye, Zhutian Chen, Xiangtong Chu, Yifan Wang, Siwei Fu, Lejun Shen, Kun Zhou, Yingcai Wu',
    year: 2021,
    title: 'Shuttlespace: Exploring and analyzing movement trajectory in immersive visualization',
    venueLong: "IEEE Transactions on Visualization & Computer Graphics (Proceedings of VIS'20)",
    venue: 'TVCG',
    url: '#',
    teaser: shuttlespace,
    pdf: shuttlespaceFile,
    video: '',
  },
  {
    authors:
      'Qianwen Wang, Zhen Li, Siwei Fu, Weiwei Cui, Huamin Qu',
    year: 2019,
    title: 'Narvis: Authoring narrative slideshows for introducing data visualization designs',
    venueLong: "IEEE Transactions on Visualization & Computer Graphics",
    venue: 'TVCG',
    url: '#',
    teaser: narvis,
    pdf: narvisFile,
    video: 'https://youtu.be/bbRBzumBrX4',
  },
  {
    authors: 'Siwei Fu, Jian Zhao, Hao-Fei Cheng, Haiyi Zhu, Jennifer Marlow',
    year: 2018,
    title:
      'T-cal: Understanding team conversational data with calendar-based visualization',
    venueLong:
      'Proceedings of the 36th annual acm conference on human factors in computing systems, 2018',
    venue: 'ACM CHI',
    url: 'https://dl.acm.org/citation.cfm?id=3174074',
    teaser: tcal,
    video: 'https://www.youtube.com/watch?v=RoPKc0T0Uis&t=1s',
    pdf: tcalFile,
  },
  {
    authors: 'Siwei Fu, Hao Dong, Weiwei Cui, Jian Zhao, Huamin Qu',
    year: 2018,
    title: 'How do ancestral traits shape family trees over generations?',
    venueLong:
      "IEEE Transactions on Visualization and Computer Graphics (Proceedings of VIS'17)",
    venue: 'TVCG',
    url: 'https://ieeexplore.ieee.org/document/8017631/',
    teaser: treeevo,
    video: 'https://www.youtube.com/watch?v=lKGJeiYRMi0&t=116s',
    pdf: treeevoFile,
  },
  {
    authors: 'Siwei Fu, Jian Zhao, Weiwei Cui, Huamin Qu',
    year: 2017,
    title: 'Visual Analysis of MOOC Forums with iForum',
    venueLong:
      "IEEE Transactionson Visualization and Computer Graphics (Proceedings of VIS'16)",
    venue: 'TVCG',
    url: 'https://ieeexplore.ieee.org/abstract/document/7534878/',
    teaser: iforum,
    video: 'https://www.youtube.com/watch?v=YwOVHexKNBM',
    pdf: iforumFile,
  },

]

var news = [
  {
    date: '18/5/25',
    content: 'The homepage is created! Tell me you like it!',
  },
  {
    date: '18/4/5',
    content: 'I come back from UC Davis. What a memorable experience!',
  },
  {
    date: '17/12/14',
    content: "Our CHI'18 paper (T-Cal) gets accepted! HaHaHaHa!",
  },
  {
    date: '17/10/11',
    content: "I am going to UC Davis to visit Prof. Kwan-Liu Ma's group.",
  },
  {
    date: '17/10/1',
    content:
      "Our paper, iForum, is presented at VIS'17. I am a little bit nervous. Come on, Siwei!",
  },
]

export { pub, }



// WEBPACK FOOTER //
// ./src/components/data.js